import { LanguageService } from 'src/app/shared/services/language.service';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpService } from 'src/app/shared/services/http.service';

@Component({
  selector: 'modal-report-global',
  templateUrl: './modal-report.component.html',
  styleUrls: ['./modal-report.component.scss']
})
export class ModalReportGlobalComponent implements OnInit, OnDestroy {


  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @Input() modalOptions: any = null;
  @Input() bloburl: any = null;

  public pdf = null;
  public isLoading: boolean = false;

    /* TRADUCCIONES */
  public jsonLanguage: any = {};
  private changeLanguage: any = {};

  constructor(
    private httpService: HttpService,
    private sanitizer: DomSanitizer,
    private languageService: LanguageService
  ) { 
    this.changeLanguage = languageService.emitChangeLanguage.subscribe(async () => {
      this.jsonLanguage = await this.languageService?.getJsonLanguege('components','modal_report_global');
    })
  }

  async ngOnInit() {
    this.jsonLanguage = await this.languageService?.getJsonLanguege('components','modal_report_global');
    this.reportPDF();
  }

  ngOnDestroy(){
    this.changeLanguage.unsubscribe();
  }

  // Servicio para generar el reporte de tipo pdf
  async reportPDF() {
    try {
      
      this.isLoading = true;
      this.httpService.getBlob(`api/${this.modalOptions.url}`, "application/json").subscribe((resp: any) => {
        let url = URL.createObjectURL(resp);
        this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      });


    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  }

  closeModal() { this.onClose.emit() }

}
